import { LOCALES } from '../../constants';

const ENGLISH = {
  [LOCALES.ENGLISH]: {
    //GLOBAL
    currencyFormat: 'USD',
    totalSales: 'Total sales',
    totalPercentageProfit: 'Total percentage profit',
    totalValueProfit: 'Total value profit',
    totalPositivation: 'Total positivation',
    totalPositivationMix: 'Total positivation mix',
    title: 'Title',
    message: 'Message',
    description: 'Description',
    dateCreation: 'Dt.criation',
    view: 'View',
    //TESTE
    hello: 'Hello',
    dashboard: 'Dashboard en-US',
    //WEEKDAY
    weekDayMonday: 'MON',
    weekDayTuesday: 'TUE',
    weekDayWednesday: 'WED',
    weekDayThursday: 'THU',
    weekDayFriday: 'FRI',
    weekDaySaturday: 'SAT',
    weekDaySunday: 'SUN',
    //COMMON
    commonTableHeaderLabelActions: 'Shares',
    commonTablePaginationLabelRowsPerPage: 'Lines per page',
    commonAppbarMenuProfile: 'User Profile',
    commonAppbarMenuLogout: 'Logout',
    commonInputSearch: 'Search ...',
    commonLoadingMessage: 'Loading...',
    commonSavingMessage: 'Saving ...',
    commonSendMessage: 'Sending...',
    commonWaitingMessage: 'Wait...',
    commonErrorMessage: 'There was an error in your request',
    commonAutocompleteSelectPlaceholder: 'Select...',
    commonButtonAddImage: 'Add',
    commonButtonRemoverImage: 'Remove',
    commonButtonReturn: 'Return',
    commonLabelDelete: 'Delete',
    commonLabelEdit: 'Edit',
    commonLabelMinimize: 'Minimize',
    commonLabelYes: 'Yes',
    commonLabelNo: 'No',
    commonAutocompleteSelectNoOptions: 'No Options',
    //SIDEBAR
    sidebarMenuItemDashboard: 'Dashboard',
    sidebarMenuItemEngine: 'Sales engine',
    sidebarMenuItemRewards: 'Rewards',
    sidebarMenuItemTrading: 'Trading engine',
    sidebarMenuItemSponsored: 'Sponsored',
    sidebarMenuItemAccess: 'Access',
    sidebarMenuItemUser: 'Users',
    sidebarMenuItemUserGroup: 'Times',
    sidebarMenuItemNotification: 'Notifications',
    sidebarMenuItemOrder: 'My orders',
    sidebarMenuItemConfiguration: 'Settings',
    //LOGIN
    loginTitle: 'Login',
    loginInputPassword: 'Password',
    loginInputUsername: 'Login',
    loginLabelRememberMe: 'Remember me on this device',
    loginLabelResetPassword: 'I forgot my password',
    loginButtonSubmit: 'Get in',
    loginLabelTitle: 'Access',
    loginLabelSubtitle: 'Enter your data below',
    loginLabelDevelopment: 'Developed by',
    loginLabelVersion: 'Version',
    loginMessageError: 'Username or password is invalid!',
    loginMesageLoading: 'Authenticating, please wait ...',
    loginMessageSuccess: 'Login successfully!',
    //RESET-PASSWORD
    resetPasswordTitle: 'I forgot my password',
    resetPasswordInputEmail: 'E-mail',
    resetPasswordLabelTitle: 'Forgot your password?',
    resetPasswordButtonSubmit: 'send request',
    resetPasswordButtonBack: 'Come back',
    resetPasswordLabelSubtitle:
      'Please enter the e-mail address associated with your account and we will send an email to reset your password.',
    resetPasswordSuccessTitle: 'Email successfully sent',
    resetPasswordSuccessSubtitle: 'We send a confirmation email to {Email}.Please check your e-mail.',
    resetPasswordLabelDevelopment: 'Developer',
    resetPasswordLabelVersion: 'Version',
    //USER-LIST
    userListTitle: 'Users',
    userListButtonAdd: 'new user',
    userListTableHeaderExternalCode: 'Code',
    userListTableHeaderName: 'Name',
    userListTableHeaderEmail: 'Email',
    userListTableHeaderUserRole: 'Occupation',
    userListTableHeaderCreatedAt: 'DT.creation',
    userListTableHeaderUpdatedAt: 'DT.update',
    //USER-FORM
    userFormTitle: 'User registration',
    userFormButtonEdit: 'Update User',
    userFormButtonNew: 'Create User',
    userFormLabelExternalCode: 'Code',
    userFormLabelNickname: 'Surname',
    userFormLabelName: 'Full name',
    userFormLabelUserRole: 'Cargo',
    userFormLabelSuperiorExternalCode: 'Supervisor',
    userFormLabelEmail: 'Email',
    userFormLabelPassword: 'Password',
    userFormLabelPasswordConfirm: 'Confirm the Password',
    userFormLabelUserSubsidiaries: 'Branches',
    userFormLabelInactive: 'Inactive',
    userFormMessageRequiredName: 'Name is mandatory',
    userFormMessageRequiredNickname: 'Nickname is required',
    userFormMessageRequiredUserRole: 'Charge is mandatory',
    userFormMessageRequiredExternalCode: 'Code is required',
    userFormMessageRequiredApproveDiscount: 'Release group is required',
    userFormMessageApproveDiscountNotVendor: 'Release group is only for users with seller role.',
    userFormMessageValidEmail: 'Enter a valid email address',
    userFormMessageRequiredEmail: 'Email is mandatory',
    userFormMessageRequiredUserSubsidiaries: 'Subsidiary is mandatory',
    userFormMessageMinPassword: 'The password must have at least 6 characters',
    userFormMessageRequiredPassword: 'Password is required',
    userFormMessageRequiredMatchPassword: 'Confirmation of password is mandatory',
    userFormMessageMatchPassword: 'Password should be equal',
    userFormMessageLastSync: 'Last synced: {lastTimestamp} - App version: {appVersion}',
    userFormLiberationGroup: 'Order Release Group',

    //TEAM-LIST
    teamListTitle: 'Times',
    teamListButtonAdd: 'New team',
    teamListTableHeaderId: 'ID',
    teamListTableHeaderName: 'Name',
    teamListTableHeaderDescription: 'Description',
    teamListTableHeaderCreatedAt: 'DT.creation',
    teamListTableHeaderUpdatedAt: 'DT.update',
    //TEAM-FORM
    teamFormTitle: 'Team registration',
    teamFormButtonEdit: 'Update Time',
    teamFormButtonNew: 'Create team',
    teamFormLabelName: 'Name',
    teamFormLabelDescription: 'Description',
    teamFormLabelUsers: 'Users',
    teamFormMessageRequiredName: 'Name is mandatory',
    teamFormMessageRequiredDescription: 'Description is mandatory',
    teamFoemMessageMinUsers: 'Users are required',
    //REWARDS-LIST
    rewardsListTitle: 'Rewards',
    rewardsListButtonAdd: 'New reward',
    rewardsListTableHeaderId: 'ID',
    rewardsListTableHeaderLabel: 'Name',
    rewardsListTableHeaderDescription: 'Description',
    rewardsListTableHeaderPrice: 'Price',
    rewardsListTableHeaderRequiredPoints: 'Spots',
    rewardsListTableHeaderCreatedAt: 'DT.creation',
    rewardsListTableHeaderUpdatedAt: 'DT.update',
    //REWARDS-FORM
    rewardsFormTitle: 'Reward registration',
    rewardsFormButtonEdit: 'Reward Reward',
    rewardsFormButtonNew: 'Reward',
    rewardsFormLabelLabel: 'Name',
    rewardsFormLabelDescription: 'Description',
    rewardsFormLabelPrice: 'Price',
    rewardsFormLabelRequiredPoints: 'Spots',
    rewardsFormLabelQuantity: 'Amount',
    rewardsMessageRequiredLabel: 'Name is mandatory',
    rewardsMessageRequiredDescription: 'Description is mandatory',
    rewardsMessageMinPrice: 'Incorrect price',
    rewardsMessageRequiredPrice: 'Price is mandatory',
    rewardsMessageMinRequiredPoints: 'Incorrect',
    rewardsMessageRequiredRequiredPoints: 'Points is mandatory',
    rewardsMessageMinQuantity: 'Incorrect amount',
    rewardsMessageRequiredQuantity: 'Quantity is mandatory',
    //SPONSORED-LIST
    sponsoredListTitle: 'Sponsored products',
    sponsoredListButtonAdd: 'New product',
    sponsoredListTableHeaderId: 'ID',
    sponsoredListTableHeaderProductExternalCode: 'Code. Product',
    sponsoredListTableHeaderProductName: 'Name',
    sponsoredListTableHeaderDescription: 'Description',
    sponsoredListTableHeaderPointsMultiplier: 'Multiplier',
    sponsoredListTableHeaderStartDate: 'Dt. inicial',
    sponsoredListTableHeaderEndData: 'Dt. final',
    sponsoredStatusExpired: 'Expired',
    sponsoredStatusValid: 'Valid',
    //SPONSORED-FORM
    sponsoredFormTitle: 'Sponsored Product Registration',
    sponsoredFormButtonEdit: 'Update Product',
    sponsoredFormButtonNew: 'Create product',
    sponsoredFormLabelStarDate: 'Initial date',
    sponsoredFormLabelEndDate: 'Data final',
    sponsoredFormLabelDescription: 'Description Benefit / Prize',
    sponsoredFormLabelPointsMultiplier: 'Multiplier',
    sponsoredFormLabelProduct: 'Product',
    sponsoredFormLabelSendNotications: 'Notify users',
    sponsoredFormLabelUseTeams: 'Restrict by team',
    sponsoredFormLabelTeams: 'Times',
    sponsoredMessageRequiredStartDate: 'Obligatory start date',
    sponsoredMessageRequiredEndDate: 'Mandatory final date',
    sponsoredMessageRequiredDescription: 'Description is mandatory',
    sponsoredMessageMinPointsMiltiplier: 'Minimum value',
    sponsoredMessageRequiredPointsMultiplier: 'Multiplier is mandatory',
    sponsoredMessageRequiredSelectedProduct: 'No selected product',
    //TRADING-LIST
    tradingListTitle: 'Trading engine',
    tradingListButtonAdd: 'New trading engine',
    tradingListTableHeaderName: 'Name',
    tradingListTableHeaderUsersAssociated: 'QTD. Users',
    //TRADING-FORM
    tradingFormTitle: 'Trading Engine Register',
    tradingFormButtonEdit: 'Update trading engine',
    tradingFormButtonNew: 'Create trading engine',
    tradingFormButtonMinimumMargin: 'Margin minima item',
    tradingFormLabelTeam: 'Time',
    tradingFormLabelMinimumMarginUser: 'Rca minimum margin',
    tradingFormLabelMinimumMarginOrder: 'Minimum margin request',
    tradingFormLabelMinimumMarginItem: 'Minimum margin item',
    tradingMessageMinMinimumMarginUser: 'Incorrect Value Minimum Margin RCA',
    tradingMessageRequiredMinimumMarginUser: 'Minimum RCA margin is mandatory',
    tradingMessageMinMinimumMarginOrder: 'Incorrect Value Margin',
    tradingMessageRequiredMinimumMarginOrder: 'Minimum margin request is mandatory',
    //CLIENT MODAL
    clientModalTitle: 'Client Details',
    clientModalTab1: 'Client',
    clientModalTab2: 'Recommendation',
    clientModalTab3: 'History',
    clientModalTab4: 'Navigate',
    clientModalTab5: 'Ratings',
    clientModalFilterButton: 'Filter',
    clientModalDateRangeInvalid: 'End date cannot be earlier than start date',

    //CLIENTS FILTER MODAL
    clientsFilterModalvisitOnMonday: 'Monday',
    clientsFilterModalvisitOnTuesday: 'Tuesday',
    clientsFilterModalvisitOnWednesday: 'Wednesday',
    clientsFilterModalvisitOnThursday: 'Thursday',
    clientsFilterModalvisitOnFriday: 'Friday',
    clientsFilterModalvisitOnSaturday: 'Saturday',
    clientsFilterModalvisitOnSunday: 'Sunday',
    clientsFilterModalVisitInput: 'Visit days',
    clientsSearchModalFilterApplyDayFilters: 'Apply day filter',

    //CLIENT FORM
    clientRatingForm: 'Rating',
    clientCommentForm: 'Comment',
    clientCommentFormRequired: 'Comment is required.',
    clientRatingFormRequired: 'Rating is required.',
    clientRatingFormEmpty: 'Customer currently has no ratings.',
    clientRatingFormCreatedMessage: 'Rating created successfully..',

    //ORDER
    orderTitle: 'My orders',
    orderTableHeaderId: 'ID',
    orderTableHeaderOrderNumber: 'Order',
    orderTableHeaderClient: 'Client',
    orderTableHeaderSubsidiary: 'Subsidiary',
    orderTableHeaderOrderStatus: 'Status',
    orderTableHeaderOrderTotal: 'Total',
    orderTableHeaderCreatedAt: 'Dt.creation',
    orderTableHeaderUpdatedAt: 'Dt.update',

    orderFilterClient: 'Client',
    orderFilterTitle: 'Order Filter',
    orderFilterStatus: 'Status',
    orderFilterPeriod: 'Period',
    orderFilterOrderType: 'Order Type',
    orderFilterOrderExternalNumber: 'ERP Order Number',
    orderFilterIsExternal: 'External Orders Only (ERP)',
    orderFilterInvoiceNumber: 'Invoice number',
    orderFilterApply: 'Apply Filters',

    //ORDER DETAIL
    orderDetailTitle: 'Order',
    orderDetailLabelStatus: 'Status',
    orderDetailLabelSubsidiary: 'Subsidiary',
    orderDetailLabelShippingType: 'Shipping',
    orderDetailLabelDate: 'Data',
    orderDetailLabelClient: 'Client',
    orderDetailLabelPaymentOption: 'Pegto',
    orderDetailLabelPaymentPlan: 'Pegto',
    orderDetailLabelObservation: 'Observation',
    orderDetailLabelProduct: 'Product',
    orderDetailLabelSoldPrice: 'Unit price',
    orderDetailLabelSoldQuantity: 'Amount',
    orderDetailLabelTotalItem: 'Total price',
    orderDetailLabelExternalCode: 'Code',
    orderDetailLabelBrand: 'Mark',
    orderDetailLabelPaymentPlanGroup1Total: 'Ethical',
    orderDetailLabelPaymentPlanGroup2Total: 'Total generico.',
    orderDetailLabelTotal: 'Total',
    orderDownloadPDF: 'Download PDF',

    //ORDER STATUS
    orderStatusAll: 'All Statuses',
    orderStatusWaitingApproval: 'Waiting for approval',
    orderStatusBudget: 'Budget',
    orderStatusProcessing: 'Processing',
    orderStatusAccepted: 'Okay',
    orderStatusBilled: 'Billed',
    orderStatusBlocked: 'locked',
    orderStatusWaitingPayment: 'Awaiting payment',
    orderStatusPending: 'Pendant',
    orderStatusReleased: 'Released',
    orderStatusMounted: 'Mounted',
    orderStatusPaid: 'Payment',
    orderStatusRejected: 'Rejected',
    orderStatusError: 'Mistake',
    orderStatusCanceled: 'Canceled',

    //ORDER CREATE
    orderCreateLabelClientEmptyRating: 'Customer does not have ratings, rate it before starting a sale.',
    orderCreateLabelClientRatingDeadline: 'Maximum time to evaluate client has expired.',
    orderCreateLabelPaymentPlanNoOptions: 'No plans found',

    //ORDER MODAL DELETE
    orderModalDeleteMessage: 'Are you sure you want to delete the order?',
    //ORDER CHECKOUT PENDENCIES
    orderCheckoutRequiredAdditionalProductToKit:
      'The order requires an additional product that is not from the same combo/kit',

    //PROMOTIONS
    promotionFormDescription: 'Description',
    promotionFormRequiredPoints: 'Required Points',
    productDetailsLabelUnitPrice: 'Unit Price',
    productDetailsLabelBrand: 'Brand',
    promotionFormLabelRequired: 'Mandatory Products',
    promotionFormLabelBonification: 'Bonus',
    promotionFormLabelReward: 'Toast / Reward',
    promotionFormLabelRequireAdditionalProductToKit: 'Require Additional Product To Kit',

    //WORKING HOURS
    workingHoursPlaceholderIn: 'of',
    workingHoursPlaceholderTill: 'until',
    workingHoursLabelAlter: 'Do you want to configure different time from the default?',
    workingHoursLabelStartFirstShift: 'Morning',
    workingHoursLabelEndFirstShift: 'Morning out',
    workingHoursLabelStartSecondShift: 'Late entrance.',
    workingHoursLabelStartEndSecondShift: 'Afterwards',
    //CONFIGURATION
    configurationTitle: 'Settings',
    configurationSectionSystemControls: 'System Controls',
    configurationSectionSalesOrderParameters: 'Parameters for sale request',
    configurationSectionPayment: 'Payments',
    configurationSectionProductPhotos: 'Product photos',
    configurationSectionShipping: 'Shipping',
    configurationSectionPointsAccelerator: 'Points acceleration',
    configurationSectionTradingFinancialIncrease: 'Financial increase on engine margins',
    configurationSectionFactors: 'Factors',
    configurationSectionWorkingHours: 'Work schedule',
    configurationButtonSave: 'Save configuration',
    configurationMessageSendImagens: 'Sending images ...',
    configurationMessageSuccessSendImagems: 'Images uploaded!',
    configurationMessageSuccess: 'Settings saved!',
    configurationMessageErrorPayment: 'Fill in the payment details',
    configurationMessageErrorEmail: 'Fill in the email details',
    configurationMessageErrorWhatsapp: 'Fill in the whatsapp data',
    configurationMessageErrorWorkingHours: 'Fill in your work hours',
    configurationDefaultPriceTableCode: 'Default Price Table Code',
    //CONFIGURATION-System Controls
    configurationLabelUseOrderModule: 'Uses Sales Force',
    configurationLabelUseNegotiationEngine: 'Uses trading engine',
    configurationLabelUseMedPromotions: 'Uses medicine control',
    configurationLabelAllowMixedBonification: 'Uses mixed bonus',
    configurationLabelAcceptBlockedSale: 'Accepts sale blocked',
    configurationLabelAcceptDiscountDelivery: 'Accepts delivery discount',
    configurationLabelAcceptSaleWithoutStock: 'Accepts sale without stock',
    configurationLabelAcceptNegativeBalance: 'Accepts negative sale',
    configurationLabelTaxation: 'Accepts taxation',
    configurationLabelDecimals: 'Decimal houses',
    configurationLabelAllowOrderDelete: 'Allows you to delete order',
    //CONFIGURATION-Sales Order Parameters
    configurationLabelUseBonificationSale: 'Permite Bonified Sale',
    configurationLabelUseShippingControl: 'Lets you select freight',
    configurationLabelAllowShippingEdit: 'Allow manual shipping fee edit',
    configurationLabelUseDefaultPaymentOption: 'Allows you to change payment method',
    configurationLabelDeliveryByCityOption: 'Allows you to select carriers by city',
    configurationLabelAllowDiscountChanging: 'Allows you to include discount',
    configurationLabelAllowComissionPromo: 'Allows you to display Commission',
    configurationLabelAllowInvoiceObservation: 'Lets you inform NF observation',
    configurationLabelUseClientRatingOption: 'Allows to evaluate customer',
    configurationLabelBlockOrderUnratedClientOption: 'Block sale to customer without review',
    configurationLabelClientRatingDeadlineOption: 'Maximum customer evaluation period',
    configurationLabelOnlyProductOnKitOption: 'Combo/Kit products only',

    //CONFIGURATION-Payment
    configurationLabelAllowPaymentLink: 'Use link payment',
    //CONFIGURATION-Api
    configurationLabelIpPrimary: 'Primary ip',
    configurationLabelIpSecondary: 'Secondary IP',
    configurationButtonTestConection: 'Test connection',
    configurationApiModalTitle: 'Connection test',
    configurationApiModalMessage: 'Message:',
    configurationApiModalMessageSuccess: 'Successful connected',
    configurationApiModalButtonRetry: 'Try again',
    configurationApiModalButtonClose: 'Close',
    //CONFIGURATION-Email
    configurationLabelPassword: 'Password',
    configurationLabelPort: 'Porta SMTP',
    configurationLabelAuthentication: 'Authentication',
    //CONFIGURATION-Trading Financial Increase
    configurationLabelInitialTime: 'Start',
    configurationLabelFinalTime: 'End',
    configurationLabelMarginIncrease: 'Margin',
    configurationButtonAddNewMargin: 'Add new margin',
    //CONFIGURATION-Factors
    configurationLabelMinimumMargin: 'Minimum margin',
    configurationLabelMaximumSalePercentage: 'Maximum increase in sales',
    configurationLabelRadiusVisit: 'Ray',
    configurationLabelStayLength: 'Minimum time time',
    configurationLabelConversionFactorGift: 'Points Factor',
    configurationLabelpointsFactorRewardValue: 'Rewards Point Factor',
    //NOTIFICAITON
    notificationTitle: 'Notification',
    notificationLabelTitle: 'Qualification',
    notificationLabelShortMessage: 'Short message',
    notificationLabelSendToAll: 'Submit to all',
    notificationLabelUsers: 'Users',
    notificationButtonSubmit: 'Send notification',
    notificationNewNotifications: 'New Notificatioins',
    notificationShowAll: 'Show all notifications',
    notificationLabelSend: 'Send',
    notificationLabelList: 'List',

    //PRODUCT DETAILS
    productDetailsLabelAlternativeProductsEmpty: "You don't have any alternative products registered",
    productDetailsLabelOriginalNumber: 'Original Number',
    productDetailsLabelLastDetails: 'Last purchase price',

    // PRODUCTS-LIST
    productsTitle: 'Products',
    productsFilterTitle: 'Product Filter',
    productsFilterLabelLocalizationItem: 'Subsidiary',
    productsFilterLabelWithStock: 'With Stock',
    productsFilterLabelWithoutStock: 'Without Stock',
    productsFilterQueryString: 'Search',
    productsFilterBrand: 'Brand',
    productsFilterButton: 'Filters',
    productsFilterCode: 'Code',
    productsFilterBarCode: 'Bar Code',
    productsFilterName: 'Name',
    productsFilterApply: 'Apply Filters',
    productsFilterStock: 'Stock',
    productsFilterPrice: 'Price',

    //accountBalance
    accountBalanceDetailsLabel: 'Seller Balance',
    accountBalanceDetailsLabelDiscount: 'Discounted Amount',
    orderCreateCheckoutObservationAccountBalance: 'Account Balance observations',
    orderCreateCheckoutInitialDateLabel: 'Start date',
    orderCreateCheckoutEndDateLabel: 'End date',
    accountBalanceMenuLabel: 'Current Account Balance',
    accountBalanceMenuStatementLabel: 'Account Statement',
    accountBalanceMenuSectionTitle: 'Current Account',
    accountBalancePreviousBalanceLabel: 'Previous balance',
    accountBalanceEmptyMessage: 'No entries found for the selected period.',
    accountBalanceOrderNumberLabel: 'Order number',
    accountBalanceSearchButtonLabel: 'Search',
    accountBalanceLoadMoreLabel: 'Load more',
    accountBalanceLoadingMoreLabel: 'Loading...',

    // Cart recommendations
    cartRecommendationPopupTitle: 'Recommended products for you',
    cartRecommendationPopupSubtitle: 'Suggestions generated from the customer history.',
    cartRecommendationPopupOpenModalButton: 'Open details',
    cartRecommendationPopupCloseButton: 'Close',
    cartRecommendationPopupRetryButton: 'Refresh list',
    cartRecommendationPopupDisableButton: "I don't want recommendations",
    cartRecommendationPopupEmpty: 'No recommendations available right now.',
    cartRecommendationFloatingLabel: 'Recommendations',
    cartRecommendationFloatingTooltip: 'Open recommendations',
    cartRecommendationOpenButton: 'View Recommendations',
    cartRecommendationPopupAllProductsLoaded: 'All products have been loaded',
    cartRecommendationPopupEmptyDescription: 'Add products to the cart to receive personalized recommendations'
  }
};

export default ENGLISH;
